import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToBooking1WithCoupon = (couponId) => {
  if (process.env.NODE_ENV == "local") {
    router.push({
      name: "MfittBooking1",
      query: { coupon_id: couponId },
    });
  } else {
    // 使うタブから遷移時にタブを切り替える必要があるので、ncOpenTicketToExpress()を使用
    nativeHandlerService.ncOpenTicketToExpress(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}mfitt/booking1?coupon_id=${couponId}`
    );
  }
};
